import type { QueryClient } from "@tanstack/react-query";
import type { TeacherClassItem } from "@/lib/services/teacherClassesService";
import { getTeacherClasses } from "@/lib/services/teacherClassesService";
import { QueryKeys } from "@/lib/types";
import { prefetchClassesByIds } from "./prefetchClassesByIds";

export async function prefetchTeacherClasses(
  queryClient: QueryClient,
  teacherId: number,
  accessToken: string,
) {
  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.TeacherClasses, teacherId],
    queryFn: () => getTeacherClasses(accessToken, teacherId),
  });

  const classes =
    queryClient.getQueryData<TeacherClassItem[]>([
      QueryKeys.TeacherClasses,
      teacherId,
    ]) ?? [];
  const classIds = classes
    .map((c) => c.classId)
    .filter((id) => Number.isFinite(id) && id > 0);

  if (classIds.length > 0) {
    await prefetchClassesByIds(queryClient, classIds, accessToken);
  }

  return { classIds };
}
